var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronRight = function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.879 9.12a3 3 0 0 1 4.242 0l12.728 12.728a3 3 0 0 1 .446 3.668q-.107.18-.24.348a3 3 0 0 1-.207.228L20.121 38.82a3 3 0 0 1-4.242-4.243L26.485 23.97 15.88 13.363a3 3 0 0 1 0-4.242"
  })));
};
export default SvgIconChevronRight;